
namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class SalesSummaryReportDialog extends _Ext.DialogBase<any, any>
    {
        public categoryid: number;
        protected getFormKey() { return SalesSummaryReportForm.formKey; }
        public form = new SalesSummaryReportForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.PendingChangesConfirmation = false;
            return opt;
        }

        constructor() {
            super();
            this.form = new SalesSummaryReportForm(this.idPrefix);
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 350;
            q.initDetailEditor(this, this.form.Categories, Config);
            q.initDetailEditor(this, this.form.Weekly, Config);
            q.initDetailEditor(this, this.form.Quarterly, Config);
            q.initDetailEditor(this, this.form.Monthly, Config);
            q.hideEditorLabel(this.form.Weekly);
            q.hideEditorLabel(this.form.Quarterly);
            q.hideEditorLabel(this.form.Monthly);
            this.form.Categories.element.height(600);
            this.form.Weekly.element.height(600);
            this.form.Monthly.element.height(800);
            this.form.Quarterly.element.height(800);

            q.SetCategorySixColumn(this.form.Categories);
            q.SetCategorySixColumn(this.form.Weekly);
            q.SetCategorySixColumn(this.form.Quarterly);
            q.SetCategorySixColumn(this.form.Monthly);
            q.HideCategoryLable(this.element);
        }
        onDialogOpen() {
            super.onDialogOpen(); 
            var categoryid = 0;
            Sales.CategoryWiseSalesService.List({ Take: 0 }, response => {
                if (response.Entities != null && response.Entities.length > 0) {
                    this.form.Categories.setdata(response.Entities, response);
                    categoryid = response.Entities[0].CategoryId;
                    this.form.Categories.setselectedrow(categoryid);
                }
            }, { async: false })
            this.setGrids(categoryid);
            q.HideDialogToolbar(this.element);
        }
        getDialogOptions() {
            var options = super.getDialogOptions();
            options.width = 1200;
            options.height = 900;
            return options;
        }
        protected getDialogTitle(): string {
            return "Sales Report";
        }
        protected getDialogButtons() {
            return [
                {
                    text: 'Ok',
                    click: () => {
                        //if (!this.validateBeforeSave())
                        //    return;

                        //if (this.form.ReasonId.value == null ||
                        //    Q.isEmptyOrNull(this.form.ReasonId.value)) {
                        //    Q.notifyError("Please Select Reason");
                        //    return;
                        //}

                        //this.reasonid = parseInt(this.form.ReasonId.value);
                        //this.checksuccess = true;
                        this.dialogClose();
                        return true;
                    },
                },
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            ];
        }
        public setGrids(categoryid: number) {

            Sales.SalesFiltersService.WeeklySales({ CategoryId: categoryid }, response => {
                if (response.Entities != null && response.Entities.length > 0) {
                    this.form.Weekly.setdata(response.Entities, response);
                }
            }, { async: false });

            Sales.SalesFiltersService.MonthlySales({ CategoryId: categoryid }, response => {
                if (response.Entities != null && response.Entities.length > 0) {
                    this.form.Monthly.setdata(response.Entities, response);
                }
            }, { async: false });
            Sales.SalesFiltersService.QuarterlySales({ CategoryId: categoryid }, response => {
                if (response.Entities != null && response.Entities.length > 0) {
                    this.form.Quarterly.setdata(response.Entities, response);
                }
            }, { async: false });

        }
    }
}